import { IconProps } from "./types";
import React from "react";

export const ApprovalsIcon = ({
  className,
  fill = "currentColor",
  width = 27,
  height = 23,
  style = {},
  textColor = "#000",
}: IconProps & {
  textColor?: string;
}): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 27 23"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M19.3991 22.9995C17.4809 22.9995 15.6494 22.2875 14.2419 20.9946C12.843 19.7096 11.9853 17.9674 11.8269 16.0889L11.7724 15.4425L11.1612 15.6598C10.3411 15.9514 9.47944 16.0992 8.6 16.0992C4.40935 16.0992 1 12.7125 1 8.5496C1 4.38674 4.40935 1 8.6 1C10.5182 1 12.3498 1.71189 13.7572 3.00453C15.1561 4.28931 16.0137 6.03136 16.1722 7.90979L16.2267 8.55622L16.8379 8.33886C17.658 8.04726 18.5196 7.8994 19.3991 7.8994C23.5898 7.8994 26.9991 11.2861 26.9991 15.449C26.9991 19.6124 23.5898 22.9995 19.3991 22.9995Z"
      fill={fill}
    />
    <path
      d="M18.8991 21.9995C22.8141 21.9995 25.9991 18.8367 25.9991 14.949C25.9991 11.0618 22.8141 7.8994 18.8991 7.8994C18.0769 7.8994 17.2716 8.03753 16.5055 8.30996L15.283 8.74468L15.174 7.45181C15.0261 5.69869 14.2253 4.0725 12.919 2.87278C11.6041 1.6651 9.89264 1 8.1 1C4.18505 1 1 4.16244 1 8.0496C1 11.9368 4.18505 15.0992 8.1 15.0992C8.92221 15.0992 9.72756 14.9611 10.4937 14.6887L11.7161 14.2541L11.8251 15.5469C11.973 17.3001 12.7739 18.9265 14.0801 20.1264C15.3951 21.3343 17.1065 21.9995 18.8991 21.9995ZM18.8991 22.9995C14.6571 22.9995 11.1768 19.7579 10.8287 15.6309C9.97609 15.9341 9.05745 16.0992 8.1 16.0992C3.6261 16.0992 0 12.4956 0 8.0496C0 3.6036 3.6261 0 8.1 0C12.342 0 15.8223 3.24082 16.1704 7.36776C17.023 7.06457 17.9417 6.8994 18.8991 6.8994C23.373 6.8994 26.9991 10.5039 26.9991 14.949C26.9991 19.395 23.373 22.9995 18.8991 22.9995Z"
      fill={fill}
    />
    <path
      d="M23 11.8058L22.1942 11L19 14.1942L15.8058 11L15 11.8058L18.1942 15L15 18.1942L15.8058 19L19 15.8058L22.1942 19L23 18.1942L19.8058 15L23 11.8058Z"
      fill={textColor}
    />
    <path
      d="M6.17821 10.5197L3.8076 8.34287L3 9.0787L6.17821 12L13 5.73583L12.1987 5L6.17821 10.5197Z"
      fill={textColor}
    />
  </svg>
);
